import { BaseTable, Loading, PermissionLink, TableHeader } from "components";
import { convertDate } from "pages/Inventori/Transaction/TransactionJournal/utils";
import { Fragment } from "react";
import { IoSendSharp } from "react-icons/io5";
import { convertNumber } from "utils";
import { useList } from "./hooks";
import { SummarySection } from 'pages/Inventori/Transaction/components'

export function TabBuild(props: { disable?: boolean, dateFrom: string, dateEnd: string }) {
  const productId = localStorage?.getItem("prdId")
  const { data, isLoading } = useList(Number(productId), props.dateFrom, props.dateEnd)

  const totalQty = data.reduce((total, item) => { return total + (item?.qty_build_unit ? Math.round(Number(item?.qty_build_unit)) : 0) }, 0);
  const totalExt = data.reduce((total, item) => { return total + (item?.component_at_cost ? Math.round(Number(item?.component_at_cost)) : 0) }, 0);
  const totaAll = totalQty * totalExt
  const totalAverage = (totaAll || 0) / (totalQty || 0)
  

  return (
    <Fragment>
      <section className="mt-2">
        <div className="overflow-x-auto">
          <BaseTable className="border-transparent">
            <TableHeader>
              <tr className="uppercase">
                <th>No</th>
                <th colSpan={props?.disable ? 1 : 2}>BUILD ID</th>
                <th>Date</th>
                <th>Description</th>
                <th>Location</th>
                <th>Qty</th>
                <th>CAC/unit</th>
                <th>Total</th>
              </tr>
            </TableHeader>
            <tbody>
              {!data.length || isLoading
                ? <tr><td colSpan={15} className="text-center"><Loading loading={isLoading} errorText={isLoading ? "" : "No data available"} /></td></tr>
                : data.map((val, index) => {
                  const total = val?.qty_build_unit * val?.component_at_cost
                  return (
                    <tr>
                      <td>{index + 1}</td>
                      {!props?.disable &&
                        <td>
                          <PermissionLink permission="IR013" to={`/inventory/transaction/build-item/edit/${val.build_id}`}>
                            <IoSendSharp />
                          </PermissionLink>
                        </td>
                      }
                      <td>{val?.trx_code ?? ""}</td>
                      <td>{val?.transaction_date ? convertDate(val?.transaction_date) : "-"}</td>
                      <td>{val?.product_name ?? "-"}</td>
                       <td>{val?.location_name ?? "-"}</td>
                      <td className="text-right">{val?.qty_build_unit ? convertNumber(Math.round(val?.qty_build_unit))?.intoNormalAmount : "-"}</td>
                      <td className="text-right">{val?.component_at_cost ? convertNumber(Math.round(val?.component_at_cost))?.intoCurrency : "-"}</td>
                      <td className="text-right">{convertNumber(Math.round(total))?.intoCurrency ?? "-"}</td>
                    </tr>
                  )
                })
              }
              <tr className="font-bold">
                <td colSpan={6} className="text-right">SUMMARY TOTAL</td>
                <td className="text-right">{totalQty ? convertNumber(totalQty)?.intoNormalAmount : "0"}</td>
                <td className="text-right">{totalExt ? convertNumber(totalExt)?.intoCurrency : "0"}</td>
                <td className="text-right">{totaAll ? convertNumber(totaAll)?.intoCurrency : "0"}</td>
              </tr>
            </tbody>
          </BaseTable>
        </div>
        <div className="flex justify-end mt-4">
          <div className="min-w-[300px]">
            <SummarySection
              label="AVERAGE"
              value={totalAverage ? convertNumber(totalAverage)?.intoCurrency : "0"}
            />
          </div>
        </div>

      </section>
    </Fragment>
  )
}